import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// PropTypes
import { jobPropTypes } from '../../../../proptypes/jobProptypes';

// Context
import ApproachContext from '../../../../context/ApproachContext';

// Utils
import { langShorthand } from '../../../../utils';

// Styles
import styles from './niceToHaveSection.module.scss';

const NiceToHaveSection = ({ job }) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  const desiredLangs = job.talent_languages.filter(
    (lang) => lang.importance === 'desired',
  );
  const hasNiceToHaveSection =
    job.extra_info?.nice_to_have ||
    // job.extra_info?.leadership_experience ||
    //   job.extra_info?.leadership_importance === 'desired'
    // (job.extra_info?.travel &&
    //   job.extra_info?.travel_importance === 'desired') ||
    desiredLangs.length > 0;
  const hasDesiredPartOfNiceToHave =
    // job.extra_info?.leadership_experience ||
    // job.extra_info?.leadership_importance === 'desired'
    // (job.extra_info?.travel &&
    //   job.extra_info?.travel_importance === 'desired') ||
    desiredLangs.length > 0;

  if (!hasNiceToHaveSection) return null;

  return (
    <section id="nice-to-haves-section" className={styles.container}>
      <h2 className={styles.heading}>
        {t(`description_page.nice_to_haves_section.title.${approach}`)}
      </h2>
      <div
        className={`html-div ${styles.content}`}
        dangerouslySetInnerHTML={{
          __html: job.extra_info?.nice_to_have,
        }}
      />

      {hasDesiredPartOfNiceToHave && (
        <div>
          <ul className={styles.list}>
            {/* {job.extra_info?.travel &&
              job.extra_info?.travel_importance === 'desired' && (
                <li>
                  {t(
                    `description_page.what_you_bring_section.travel_requirement.${approach}`,
                  )}
                  <span className={styles.separator}>:</span>{' '}
                  {job.extra_info?.travel_details ||
                    t(`questions_page.yes_no_values.yes.${approach}`)}
                </li>
              )} */}

            {/* {job.extra_info?.leadership_experience && (
              job.extra_info?.leadership_importance === 'desired' &&
              <li>
                {t(
                  `description_page.what_you_bring_section.experience.${approach}`,
                )}
                <span className={styles.separator}>:</span>{' '}
                {t(
                  `description_page.what_you_bring_section.management_role.${approach}`,
                )}
              </li>
            )} */}

            {desiredLangs.map((language) => (
              <li key={language.mid}>
                <span className={styles.language}>
                  {language.display?.[langShorthand(job.job_language.mid)] ??
                    language.mid}
                </span>
                <span className={styles.separator}>:</span>{' '}
                {t(
                  `description_page.language_proficiency.${language.level}.${approach}`,
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};

NiceToHaveSection.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
};

export default NiceToHaveSection;
